import { lazy } from "react";
import { route, routes } from "~/helpers/routeHelper";

const Dashboard = lazy(() => import("~/pages/Dashboard/index"));
const LeaderboardList = lazy(() => import("~/pages/Dashboard/Leaderboard"));
const UserList = lazy(() => import("~/pages/User/List"));
const UserView = lazy(() => import("~/pages/User/View"));
const UserNew = lazy(() => import("~/pages/User/New"));
const DealerGroupView = lazy(() => import("~/pages/DealerGroup/View"));
const DealerRegionList = lazy(() => import("~/pages/DealerRegion/List"));
const DealerRegionView = lazy(() => import("~/pages/DealerRegion/View"));
const DealerRegionNew = lazy(() => import("~/pages/DealerRegion/New"));
const DealerRegionNewManager = lazy(() => import("~/pages/DealerRegion/New/Manager"));
const DealerStoreList = lazy(() => import("~/pages/DealerStore/List"));
const DealerStoreView = lazy(() => import("~/pages/DealerStore/View"));
const DealerStoreNew = lazy(() => import("~/pages/DealerStore/New"));
const DealerStoreNewManager = lazy(() => import("~/pages/DealerStore/New/Manager"));
const DealerStoreSignerView = lazy(() => import("~/pages/DealerStoreSigner/View"));
const DealerStoreSignerNew = lazy(() => import("~/pages/DealerStoreSigner/New"));
const OrderList = lazy(() => import("~/pages/Order/List"));
const OrderViewIndex = lazy(() => import("~/pages/Order/View"));
const OrderViewVid = lazy(() => import("~/pages/Order/View/Vid"));
const OrderViewInkSign = lazy(() => import("~/pages/Order/View/InkSign"));
const OrderViewESign = lazy(() => import("~/pages/Order/View/ESign"));
const OrderViewFinance = lazy(() => import("~/pages/Order/View/Finance"));
const OrderViewSupporting = lazy(() => import("~/pages/Order/View/Supporting"));
const OrderViewActivity = lazy(() => import("~/pages/Order/View/Activity"));
const OrderViewMessages = lazy(() => import("~/pages/Order/View/Messages"));
const OrderNewIndex = lazy(() => import("~/pages/Order/New"));
const OrderNewInstructions = lazy(() => import("~/pages/Order/New/Instructions"));
const OrderNewCustomer = lazy(() => import("~/pages/Order/New/Customer"));
const OrderNewVehicle = lazy(() => import("~/pages/Order/New/Vehicle"));
const OrderNewContract = lazy(() => import("~/pages/Order/New/Contract"));
const OrderNewDocuments = lazy(() => import("~/pages/Order/New/Documents"));
const OrderNewConfirmation = lazy(() => import("~/pages/Order/New/Confirmation"));
const Seal = lazy(() => import("~/pages/Order/View/Seal"));
const NotificationView = lazy(() => import("~/pages/Notification/View"));
const CustomerCallList = lazy(() => import("~/pages/CustomerCall/List"));
const CustomerCallNew = lazy(() => import("~/pages/CustomerCall/New"));
const NotificationList = lazy(() => import("~/pages/Notification/List"));
const SubscriptionSetupStore = lazy(() => import("~/pages/Subscription/Setup/Store"));
const SubscriptionSetupPlan = lazy(() => import("~/pages/Subscription/Setup/Plan"));
const SubscriptionSetupPayment = lazy(() => import("~/pages/Subscription/Setup/Payment"));
const SubscriptionSetupPaymentConf = lazy(() => import("~/pages/Subscription/Setup/PaymentConf"));
const SubscriptionSetupOverview = lazy(() => import("~/pages/Subscription/Setup/Overview"));
const SubscriptionSetupForbidden = lazy(() => import("~/pages/Subscription/Setup/Forbidden"));
const SubscriptionView = lazy(() => import("~/pages/Subscription/View"));
const DealerStatementList = lazy(() => import("~/pages/Statement/Dealer/List"));
const DealerStatementView = lazy(() => import("~/pages/Statement/Dealer/View"));
const RedFlags = lazy(() => import("~/pages/Order/New/RedFlags"));
const PaymentsList = lazy(() => import("~/pages/Payments/List"));
const GroupUsageReport = lazy(() => import("~/pages/GroupUsageReport/GroupUsage"));
const DealerSalesReport = lazy(() => import("~/pages/DealerSalesReport/DealerSales"));
const HelpList = lazy(() => import("~/pages/Help/List"));
const OrderViewChannel = lazy(() => import("~/pages/Order/View/Channel"));
const GenerateLabelIndex = lazy(() => import("~/pages/Order/Partial/GenerateLabel"));
const InsuranceVerificationIndex = lazy(() => import("~/pages/Order/Partial/InsuranceVerification"));
const RouteOne = lazy(() => import("~/pages/MarketingPages/RouteOne"));
const Fedex = lazy(() => import("~/pages/MarketingPages/Fedex"));
const InsuranceVerification = lazy(() => import("~/pages/MarketingPages/InsuranceVerification"));
const CommercialOrders = lazy(() => import("~/pages/MarketingPages/CommercialOrders"));
const PriceIncrease = lazy(() => import("~/pages/MarketingPages/PriceIncrease"));
const DocumentTemplates = lazy(() => import("~/pages/DocumentTemplates/index"));
const InstantPaymentView = lazy(() => import("~/pages/InstantPayment"));
const Vehicles = lazy(() => import("~/pages/Vehicles/List"));
const DealerInvoicesList = lazy(() => import("~/pages/Accounting/List"));
const ContactUs = lazy(() => import("~/pages/ContactUs/index"));
const NewAiOrder = lazy(() => import("~/pages/Order/NewAi"));
const EditAiPrompt = lazy(() => import("~/pages/Order/NewAi/Partial/EditPrompt"));
const PricingList = lazy(() => import("~/pages/Pricing/List"));

const publicRoutes = [

];

const protectedRoutes = [
  { path: route(routes.list_users), component: UserList },
  { path: route(routes.view_user), component: UserView },
  { path: route(routes.new_user), component: UserNew },

  { path: route(routes.view_dealer_group), component: DealerGroupView },

  { path: route(routes.list_dealer_regions), component: DealerRegionList },
  { path: route(routes.view_dealer_region), component: DealerRegionView },
  { path: route(routes.new_dealer_region), component: DealerRegionNew },
  { path: route(routes.new_dealer_region_manager), component: DealerRegionNewManager },

  { path: route(routes.list_dealer_stores), component: DealerStoreList },
  { path: route(routes.view_dealer_store), component: DealerStoreView },
  { path: route(routes.new_dealer_store), component: DealerStoreNew },
  { path: route(routes.new_dealer_store_manager), component: DealerStoreNewManager },
  { path: route(routes.new_dealer_store_signer), component: DealerStoreSignerNew },

  { path: route(routes.view_dealer_store_signer), component: DealerStoreSignerView },

  { path: route(routes.list_orders), component: OrderList },
  { path: route(routes.new_order_customer), component: OrderNewCustomer },
  { path: route(routes.new_order_vehicle), component: OrderNewVehicle },
  { path: route(routes.new_order_contract), component: OrderNewContract },
  { path: route(routes.new_order_documents), component: OrderNewDocuments },
  { path: route(routes.new_order_confirm), component: OrderNewConfirmation },
  { path: route(routes.new_order_instructions), component: OrderNewInstructions },
  { path: route(routes.view_order_vid), component: OrderViewVid },
  { path: route(routes.view_order_ink_sign), component: OrderViewInkSign },
  { path: route(routes.view_order_e_sign), component: OrderViewESign },
  { path: route(routes.view_order_finance), component: OrderViewFinance },
  { path: route(routes.view_order_supporting), component: OrderViewSupporting },
  { path: route(routes.view_order_activity), component: OrderViewActivity },
  { path: route(routes.view_order_messages), component: OrderViewMessages },
  { path: route(routes.view_order_channel), component: OrderViewChannel },
  { path: route(routes.view_order), component: OrderViewIndex },
  { path: route(routes.new_order), component: OrderNewIndex },
  { path: route(routes.view_seal), component: Seal },
  { path: route(routes.view_order_generate_label), component: GenerateLabelIndex },
  { path: route(routes.view_order_insurance), component: InsuranceVerificationIndex },
  { path: route(routes.new_ai_order), component: NewAiOrder },
  { path: route(routes.edit_ai_order), component: NewAiOrder },
  { path: route(routes.edit_ai_prompt), component: EditAiPrompt },

  { path: route(routes.list_dealers_statements), component: DealerStatementList },
  { path: route(routes.view_dealer_statement), component: DealerStatementView },

  { path: route(routes.list_dealer_invoices), component: DealerInvoicesList },

  { path: route(routes.view_notification), component: NotificationView },
  { path: route(routes.list_notifications), component: NotificationList },

  { path: route(routes.list_customer_calls), component: CustomerCallList },
  { path: route(routes.new_customer_call), component: CustomerCallNew },

  { path: route(routes.setup_subscription_store), component: SubscriptionSetupStore, isSetupRoute: true },
  { path: route(routes.setup_subscription_plan), component: SubscriptionSetupPlan, isSetupRoute: true },
  { path: route(routes.setup_subscription_payment), component: SubscriptionSetupPayment, isSetupRoute: true },
  { path: route(routes.setup_subscription_payment_conf), component: SubscriptionSetupPaymentConf, isSetupRoute: true },
  { path: route(routes.setup_subscription_overview), component: SubscriptionSetupOverview, isSetupRoute: true },
  { path: route(routes.setup_subscription_forbidden), component: SubscriptionSetupForbidden, isSetupRoute: true },

  { path: route(routes.view_subscription), component: SubscriptionView },

  { path: route(routes.list_leaderboard), component: LeaderboardList },

  { path: route(routes.view_red_flag), component: RedFlags },

  { path: route(routes.home), component: Dashboard },

  { path: route(routes.list_payments), component: PaymentsList },

  { path: route(routes.view_group_usage_report), component: GroupUsageReport },
  { path: route(routes.view_dealer_sales_report), component: DealerSalesReport },

  { path: route(routes.list_help), component: HelpList },

  { path: route(routes.route_one), component: RouteOne },

  { path: route(routes.view_fedex), component: Fedex },

  { path: route(routes.view_insurance_verification), component: InsuranceVerification },

  { path: route(routes.view_commercial_orders), component: CommercialOrders },

  { path: route(routes.view_price_increase), component: PriceIncrease },

  { path: route(routes.view_document_templates), component: DocumentTemplates },

  { path: route(routes.view_pricing), component: PricingList },

  { path: route(routes.instant_payment), component: InstantPaymentView },

  { path: route(routes.view_contact_us), component: ContactUs },

  { path: route(routes.view_vehicles), component: Vehicles },
];

export { publicRoutes, protectedRoutes }
